import ApiService from "@/api.service";
import API from "@/API";


export const GET_LIST_TEMPLATE = "GET_LIST_TEMPLATE_TEMPLATE_SIZE";
export const SAVE_CUSTOM_DESIGN = "SAVE_CUSTOM_DESIGN";
export const GET_CUSTOM_DESIGN = "GET_CUSTOM_DESIGN";

export const SET_LIST_TEMPLATE = "SET_LIST_TEMPLATE";
export const SET_CUSTOM_DESIGN = "SET_CUSTOM_DESIGN";

const state = {
    templateTemplateSizes: [],
    custom_design: [],
};

const getters = {
    templateTemplateSizes(state) {
        return state.templateTemplateSizes;
    },
    customDesign(state) {
        return state.custom_design;
    },

};

const actions = {
    [GET_LIST_TEMPLATE](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_TEMPLATE_TEMPLATE_SIZE}`).then(({data}) => {
                if (data) {
                    context.commit(SET_LIST_TEMPLATE, data);
                }
                resolve(data);
            });
        });
    },
    [GET_CUSTOM_DESIGN](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_CUSTOM_DESIGN}`).then(({data}) => {
                if (data) {
                    context.commit(SET_CUSTOM_DESIGN, data);
                }
                resolve(data);
            });
        });
    },

    [SAVE_CUSTOM_DESIGN](context, payload) {
        return new Promise(resolve => {
            ApiService.post(`${API.SAVE_CUSTOM_DESIGN}`, payload).then(({data}) => {
                resolve(data);
            });
        });
    },

};

const mutations = {
    [SET_LIST_TEMPLATE](state, data) {
        state.templateTemplateSizes = data.templates;

    },
    [SET_CUSTOM_DESIGN](state, data) {
        state.custom_design = data.data;

    },

};

export default {
    state,
    actions,
    mutations,
    getters
};